/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';

export default function Divider() {
    return <hr className="rec-divider" />;
}
